import api from './api';

class BookingsService {
  // Get all bookings with filters and pagination
  async getBookings(params = {}) {
    try {
      const response = await api.get('/bookings', { params });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Get booking by ID
  async getBooking(id) {
    try {
      const response = await api.get(`/bookings/${id}`);
      return response.data.booking;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Update booking
  async updateBooking(id, data) {
    try {
      const response = await api.put(`/bookings/${id}`, data);
      return response.data.booking;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Delete booking
  async deleteBooking(id) {
    try {
      const response = await api.delete(`/bookings/${id}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Bulk update bookings
  async bulkUpdateBookings(data) {
    try {
      const response = await api.post('/bookings/bulk', data);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Export bookings
  async exportBookings(params = {}) {
    try {
      const response = await api.get('/bookings/export', {
        params,
        responseType: 'blob'
      });
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      
      // Get filename from response headers
      const disposition = response.headers['content-disposition'];
      const filename = disposition 
        ? disposition.split('filename=')[1]?.replace(/['"]/g, '') 
        : 'bookings_export.csv';
      
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      return { success: true, message: 'Export completed successfully' };
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Get booking status options
  getStatusOptions() {
    return [
      { value: 'pending', label: 'Pending', color: '#ff9800' },
      { value: 'confirmed', label: 'Confirmed', color: '#2196f3' },
      { value: 'completed', label: 'Completed', color: '#9c27b0' },
    ];
  }

  // Handle API errors
  handleError(error) {
    if (error.response?.data?.message) {
      return new Error(error.response.data.message);
    } else if (error.message) {
      return new Error(error.message);
    } else {
      return new Error('An unexpected error occurred');
    }
  }
}

export default new BookingsService();